<template>
  <div id="anchor-coupon" class="form-card">
    <div style="position: relative;">
      <AGCLabel>
        <h4>設定問題</h4>
        <template v-slot:subLabel>
          (最多可設定5條問題)
        </template>
      </AGCLabel>

      <b-button class="btn--add-question" :variant="'outline-primary'"
        :disabled="readOnly" @click="addQuestion()">
        <b-icon-plus scale="1.6"></b-icon-plus>添加問題
      </b-button>
      <span v-if="showLengthError" class="limit">(最多只可設定5條問題)</span>
    </div>

    <div v-for ="(question, index) in inputVal.questions" :key="`question-${index}`">
      <CustomQuestionItem
        @update="onQuestionItemUpdate($event, index)"
        @delete="onQuestionItemDelete(index)"
        :readOnly="readOnly"
        :questionIndex="index"
        :question="question">
      </CustomQuestionItem>
    </div>

  </div>

</template>

<script>
import CustomQuestionItem from '@/components/coupon/CustomQuestionItem.vue';
import {
  BButton,
  BIconPlus,
} from 'bootstrap-vue';
import AGCLabel from '../form/AGCLabel.vue';
import formMixin from '../../mixins/form';
import vModelMixin from '../../mixins/v-model';

export default {
  mixins: [formMixin, vModelMixin],
  components: {
    CustomQuestionItem,
    BButton,
    BIconPlus,
    AGCLabel,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    isUFUN: {
      type: Boolean,
    },
  },
  data: () => ({
    showLengthError: false,
    // questions: [
    //   // {"question #1": "hints #1", "question #2": "hints #2"}
    // ],
  }),
  methods: {
    onQuestionItemUpdate(val, index) {
      // console.log(this.inputVal.questions);
      // console.log(this.inputVal.questions[index], val);
      this.inputVal.questions[index] = val;
    },
    onQuestionItemDelete(index) {
      // console.log(this.inputVal.questions);
      // console.log(this.inputVal.questions[index], val);
      this.inputVal.questions.splice(index, 1);
      this.showLengthError = false;
    },
    addQuestion() {
      if (this.inputVal.questions.length < 5) {
        this.inputVal.questions.push({
          compulsory: false,
          question: null,
          hints: null,
          questionType: 'default',
        });
      } else {
        this.showLengthError = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
label + #keyword-filter {
  input {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
.custom-date{
  display:inline-block !important;
}

.limit {
  color: red;
  font-size: 12px;
  display: flex;
  flex-flow: wrap;
}

.btn--add-question {
  top: 30%;
  font-size: 14px;
  font-weight: 400;
  border-style: none;
  position: absolute;
  right: 2%;
}

::v-deep.desc{
    img {
        max-width: 100% !important;
      }
  }
</style>
